<template>
    <div data-component="PageLoadingSpinner"
         class="page-loading-spinner"
         :class="{
             'page-loading-spinner--light': color === 'light',
         }">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <p v-if="text">
            {{ text }}
        </p>
        <p v-else-if="lang">
            {{ l(lang) }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'PageLoadingSpinner',

    props: {
        lang: {
            type: String,
            default: 'LOADING',
        },

        text: {
            type: String,
            default: null,
        },

        /**
         * Options are 'light' or 'dark'.
         * Note: This only applies on desktop because on mobile its always on top of a light background.
         */
        color: {
            type: String,
            default: 'dark',
        },
    },
};
</script>

<style lang="less">
@import "../../less/variables";

.page-loading-spinner {
    padding: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    grid-gap: @half-gutter-width;
    color: @text-muted;

    i {
        font-size: 30px;
    }

    p {
        margin: 0;
        font-size: 16px;
    }
}

@media (min-width: @non-mobile-min) {
    .page-loading-spinner {
        &--light {
            color: @white;
        }
    }
}
</style>
